<template>
    <header class="o-header header">
        <AHeroTitle text="Terminal hospital map"/>
        <ADate />
        <ALogo />
        <ADropdown
            v-model="locale"
            :items="dropdownOptions"
            name-field="label"
            key-field="value"
            @onChange="handleChangeLocale"
            @onOpenChange="handleOpenClose"
        />
    </header>
</template>

<script>
import {
    mapState,
    mapGetters,
    mapActions
} from 'vuex';

import ADate from '../../atoms/a-date/a-date';
import ALogo from '../../atoms/a-logo/a-logo';
import ADropdown from '../../atoms/a-dropdown/a-dropdown';
import ACompanyInfo from '../../atoms/a-company-info/a-company-info';
import AHeroTitle from '../../atoms/a-hero-title/a-hero-title';

import { GUIDE_SCREEN } from '../../../utils/constants/pages';
import {
    SHOW_OVERLAY,
    RESTORE_LOCALE
} from '../../../utils/constants/bus-events-constants';

export default {
    name: "o-header",
    components: {
        ADate,
        ALogo,
        ADropdown,
        AHeroTitle
    },
    data() {
        return {
            locale: this.$i18n.locale()
        }
    },
    computed: {
        ...mapState({
            languages: state => state.map.meta.languages,
            defaultLocale: state => state.map.meta.language
        }),
        ...mapGetters([
            'getActiveLocale'
        ]),
        dropdownOptions() {
            const result = [];
            this.languages.forEach(item => {
                result.push({
                    value: item,
                    label: this.$t(`ui.language-${item}`)
                })
            });
            return result;
        }
    },
    mounted() {
        this.locale = this.getActiveLocale;
        this.initEventsListeners();
    },
    beforeDestroy() {
        this.deactivateEventsListeners();
    },
    methods: {
        ...mapActions([
            'changeLocale'
        ]),
        initEventsListeners() {
            this.$bus.$on(RESTORE_LOCALE, this.restoreLocale);
        },
        deactivateEventsListeners() {
            this.$bus.$off(RESTORE_LOCALE, this.restoreLocale);
        },
        handleChangeLocale(locale) {
            this.changeLocale(locale);
        },
        handleOpenClose(val) {
            this.$bus.$emit(SHOW_OVERLAY, val);
        },
        restoreLocale() {
            this.handleChangeLocale(this.defaultLocale);
            this.locale = this.defaultLocale;
        }
    }
}
</script>

<style lang="scss">
@import "o-header";
</style>
